import {
	type DependencyList,
	type EffectCallback,
	useEffect,
	useRef,
} from "react";

// an effect that runs on updates, not on initial render
export const useUpdateEffect: typeof useEffect = (
	effect: EffectCallback,
	deps?: DependencyList,
) => {
	const isFirst = useRef(true);

	useEffect(() => {
		if (isFirst.current) {
			isFirst.current = false;
			return;
		}

		return effect();
	}, deps);
};
